
export async function instantiate(imports={}, runInitializer=true) {
    imports['_cachedJsObjects_'] = imports['_cachedJsObjects_'] ?? new WeakMap();
    const cachedJsObjects = imports['_cachedJsObjects_'];

    // ref must be non-null
    function getCachedJsObject(ref, ifNotCached) {
        if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
        const cached = cachedJsObjects.get(ref);
        if (cached !== void 0) return cached;
        cachedJsObjects.set(ref, ifNotCached);
        return ifNotCached;
    }


    imports['./skiko.mjs'] = imports['./skiko.mjs'] ?? await import('./skiko.mjs');
    imports['@js-joda/core'] = imports['@js-joda/core'] ?? await import('@js-joda/core');

    const _ref_Li9za2lrby5tanM_ = imports['./skiko.mjs'];
    const _ref_Li9za2lrby5tanM_c2tpa29BcGk = imports['./skiko.mjs'].skikoApi;
    const _ref_QGpzLWpvZGEvY29yZQ_ = imports['@js-joda/core'];

    const wasmJsTag = WebAssembly.JSTag;
    const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

    const js_code = {
        'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
        'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
        'kotlin.wasm.internal.stringLength' : (x) => x.length,
        'kotlin.wasm.internal.jsExportStringToWasm' : (src, srcOffset, srcLength, dstAddr) => { 
            const mem16 = new Uint16Array(wasmExports.memory.buffer, dstAddr, srcLength);
            let arrayIndex = 0;
            let srcIndex = srcOffset;
            while (arrayIndex < srcLength) {
                mem16.set([src.charCodeAt(srcIndex)], arrayIndex);
                srcIndex++;
                arrayIndex++;
            }     
             },
        'kotlin.wasm.internal.importStringFromWasm' : (address, length, prefix) => { 
            const mem16 = new Uint16Array(wasmExports.memory.buffer, address, length);
            const str = String.fromCharCode.apply(null, mem16);
            return (prefix == null) ? str : prefix + str;
             },
        'kotlin.wasm.internal.getJsEmptyString' : () => '',
        'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
        'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
        'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
        'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
        'kotlin.wasm.internal.externrefHashCode' : 
        (() => {
        const dataView = new DataView(new ArrayBuffer(8));
        function numberHashCode(obj) {
            if ((obj | 0) === obj) {
                return obj | 0;
            } else {
                dataView.setFloat64(0, obj, true);
                return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
            }
        }
        
        const hashCodes = new WeakMap();
        function getObjectHashCode(obj) {
            const res = hashCodes.get(obj);
            if (res === undefined) {
                const POW_2_32 = 4294967296;
                const hash = (Math.random() * POW_2_32) | 0;
                hashCodes.set(obj, hash);
                return hash;
            }
            return res;
        }
        
        function getStringHashCode(str) {
            var hash = 0;
            for (var i = 0; i < str.length; i++) {
                var code  = str.charCodeAt(i);
                hash  = (hash * 31 + code) | 0;
            }
            return hash;
        }
        
        return (obj) => {
            if (obj == null) {
                return 0;
            }
            switch (typeof obj) {
                case "object":
                case "function":
                    return getObjectHashCode(obj);
                case "number":
                    return numberHashCode(obj);
                case "boolean":
                    return obj ? 1231 : 1237;
                default:
                    return getStringHashCode(String(obj)); 
            }
        }
        })(),
        'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
        'kotlin.wasm.internal.intToExternref' : (x) => x,
        'kotlin.wasm.internal.getJsTrue' : () => true,
        'kotlin.wasm.internal.getJsFalse' : () => false,
        'kotlin.wasm.internal.newJsArray' : () => [],
        'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
        'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
        'kotlin.js.jsCatch' : (f) => { 
            let result = null;
            try { 
                f();
            } catch (e) {
               result = e;
            }
            return result;
             },
        'kotlin.js.__convertKotlinClosureToJsClosure_(()->Unit)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Unit)'](f, )),
        'kotlin.js.jsThrow' : (e) => { throw e; },
        'kotlin.io.printlnImpl' : (message) => console.log(message),
        'kotlin.js.jsArrayGet' : (array, index) => array[index],
        'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
        'kotlin.js.JsArray_$external_fun' : () => new Array(),
        'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
        'kotlin.js.stackPlaceHolder_js_code' : () => (''),
        'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
        'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
        'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
        'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
        'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
        'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
        'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
        'kotlin.js.JsString_$external_class_get' : () => JsString,
        'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
        'kotlin.js.__convertKotlinClosureToJsClosure_((Js?)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Js?)'](f, p0)),
        'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
        'kotlin.js.__convertKotlinClosureToJsClosure_((Js)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Js?)'](f, p0)),
        'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
        'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
        'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
        'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
        'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
        'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
        'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
        'kotlin.time.dateNow' : () => Date.now(),
        'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
        'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
        'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
        'kotlinx.coroutines.error_$external_fun' : (_this, p0) => _this.error(p0),
        'kotlinx.coroutines.console_$external_prop_getter' : () => console,
        'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
        'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
        'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
        'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
            const handler = (event) => {
                if (event.source == window && event.data == 'dispatchCoroutine') {
                    event.stopPropagation();
                    process();
                }
            }
            window.addEventListener('message', handler, true);
        },
        'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
        'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
        'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
        'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
        'org.khronos.webgl.getMethodImplForUint8Array' : (obj, index) => obj[index],
        'org.khronos.webgl.getMethodImplForInt8Array' : (obj, index) => obj[index],
        'org.khronos.webgl.Int8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
        'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
        'org.khronos.webgl.slice_$external_fun' : (_this, p0, p1, isDefault0) => _this.slice(p0, isDefault0 ? undefined : p1, ),
        'org.khronos.webgl.Uint8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Uint8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
        'org.khronos.webgl.length_$external_prop_getter_1' : (_this) => _this.length,
        'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
        'org.khronos.webgl.byteOffset_$external_prop_getter' : (_this) => _this.byteOffset,
        'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
        'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
        'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
        'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
        'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
        'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
        'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
        'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
        'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
        'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
        'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
        'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
        'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
        'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
        'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
        'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
        'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
        'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
        'org.w3c.dom.events.Event_$external_class_get' : () => Event,
        'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
        'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
        'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
        'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
        'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
        'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
        'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
        'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
        'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
        'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
        'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
        'org.w3c.dom.events.__convertKotlinClosureToJsClosure_((Js)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Unit)'](f, p0)),
        'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
        'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
        'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
        'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
        'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
        'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
        'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
        'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
        'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
        'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
        'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
        'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
        'org.w3c.dom.events.MouseEvent_$external_class_instanceof' : (x) => x instanceof MouseEvent,
        'org.w3c.dom.events.MouseEvent_$external_class_get' : () => MouseEvent,
        'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
        'org.w3c.dom.events.isComposing_$external_prop_getter_1' : (_this) => _this.isComposing,
        'org.w3c.dom.events.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
        'org.w3c.dom.events.InputEvent_$external_class_get' : () => InputEvent,
        'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
        'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
        'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
        'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
        'org.w3c.dom.events.data_$external_prop_getter_1' : (_this) => _this.data,
        'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
        'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
        'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
        'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
        'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
        'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
        'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
        'org.w3c.dom.__convertKotlinClosureToJsClosure_((Double)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Double)->Unit)'](f, p0)),
        'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
        'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
        'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
        'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
        'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
        'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
        'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
        'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
        'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
        'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
        'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
        'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
        'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
        'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
        'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
        'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
        'org.w3c.dom.binaryType_$external_prop_setter' : (_this, v) => _this.binaryType = v,
        'org.w3c.dom.close_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.close(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
        'org.w3c.dom.send_$external_fun' : (_this, p0) => _this.send(p0),
        'org.w3c.dom.send_$external_fun_1' : (_this, p0) => _this.send(p0),
        'org.w3c.dom.Companion_$external_object_getInstance' : () => ({}),
        'org.w3c.dom.data_$external_prop_getter' : (_this) => _this.data,
        'org.w3c.dom.code_$external_prop_getter' : (_this) => _this.code,
        'org.w3c.dom.reason_$external_prop_getter' : (_this) => _this.reason,
        'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
        'org.w3c.dom.caches_$external_prop_getter' : (_this) => _this.caches,
        'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
        'org.w3c.dom.readyState_$external_prop_getter' : (_this) => _this.readyState,
        'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
        'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
        'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
        'org.w3c.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
        'org.w3c.dom.namespaceURI_$external_prop_getter' : (_this) => _this.namespaceURI,
        'org.w3c.dom.localName_$external_prop_getter' : (_this) => _this.localName,
        'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
        'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
        'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
        'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
        'org.w3c.dom.getAttributeNS_$external_fun' : (_this, p0, p1) => _this.getAttributeNS(p0, p1),
        'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
        'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
        'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
        'org.w3c.dom.Element_$external_class_instanceof' : (x) => x instanceof Element,
        'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
        'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
        'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
        'org.w3c.dom.getItem_$external_fun' : (_this, p0) => _this.getItem(p0),
        'org.w3c.dom.setItem_$external_fun' : (_this, p0, p1) => _this.setItem(p0, p1),
        'org.w3c.dom.nodeName_$external_prop_getter' : (_this) => _this.nodeName,
        'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
        'org.w3c.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
        'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
        'org.w3c.dom.lookupPrefix_$external_fun' : (_this, p0) => _this.lookupPrefix(p0),
        'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
        'org.w3c.dom.Node_$external_class_instanceof' : (x) => x instanceof Node,
        'org.w3c.dom.Node_$external_class_get' : () => Node,
        'org.w3c.dom.Companion_$external_object_getInstance_1' : () => ({}),
        'org.w3c.dom.append_$external_fun' : (_this, p0) => _this.append(...p0),
        'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
        'org.w3c.dom.identifier_$external_prop_getter' : (_this) => _this.identifier,
        'org.w3c.dom.clientX_$external_prop_getter' : (_this) => _this.clientX,
        'org.w3c.dom.clientY_$external_prop_getter' : (_this) => _this.clientY,
        'org.w3c.dom.Touch_$external_class_instanceof' : (x) => x instanceof Touch,
        'org.w3c.dom.Touch_$external_class_get' : () => Touch,
        'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
        'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
        'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
        'org.w3c.dom.Companion_$external_object_getInstance_2' : () => ({}),
        'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
        'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
        'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
        'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
        'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
        'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
        'org.w3c.dom.targetTouches_$external_prop_getter' : (_this) => _this.targetTouches,
        'org.w3c.dom.changedTouches_$external_prop_getter' : (_this) => _this.changedTouches,
        'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
        'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
        'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
        'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
        'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
        'org.w3c.dom.parsing.DOMParser_$external_fun' : () => new DOMParser(),
        'org.w3c.dom.parsing.parseFromString_$external_fun' : (_this, p0, p1) => _this.parseFromString(p0, p1),
        'org.w3c.fetch.status_$external_prop_getter' : (_this) => _this.status,
        'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
        'org.w3c.fetch.statusText_$external_prop_getter' : (_this) => _this.statusText,
        'org.w3c.fetch.headers_$external_prop_getter' : (_this) => _this.headers,
        'org.w3c.fetch.body_$external_prop_getter' : (_this) => _this.body,
        'org.w3c.fetch.clone_$external_fun' : (_this, ) => _this.clone(),
        'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
        'org.w3c.fetch.get_$external_fun' : (_this, p0) => _this.get(p0),
        'org.w3c.fetch.Companion_$external_object_getInstance' : () => ({}),
        'org.w3c.files.slice_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.slice(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
        'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
        'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
        'org.w3c.workers.CacheQueryOptions_js_code' : (ignoreSearch, ignoreMethod, ignoreVary, cacheName) => ({ ignoreSearch: ignoreSearch, ignoreMethod: ignoreMethod, ignoreVary: ignoreVary, cacheName: cacheName }),
        'org.w3c.workers.match_$external_fun' : (_this, p0, p1, isDefault0) => _this.match(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.workers.put_$external_fun' : (_this, p0, p1) => _this.put(p0, p1),
        'org.w3c.workers.open_$external_fun' : (_this, p0) => _this.open(p0),
        'org.w3c.workers.delete_$external_fun' : (_this, p0) => _this.delete(p0),
        'org.w3c.xhr.XMLHttpRequest_$external_fun' : () => new XMLHttpRequest(),
        'org.w3c.xhr.status_$external_prop_getter' : (_this) => _this.status,
        'org.w3c.xhr.open_$external_fun' : (_this, p0, p1, p2, p3, p4, isDefault0, isDefault1) => _this.open(p0, p1, p2, isDefault0 ? undefined : p3, isDefault1 ? undefined : p4, ),
        'org.w3c.xhr.send_$external_fun' : (_this, ) => _this.send(),
        'org.w3c.xhr.overrideMimeType_$external_fun' : (_this, p0) => _this.overrideMimeType(p0),
        'kotlinx.browser.window_$external_prop_getter' : () => window,
        'kotlinx.browser.localStorage_$external_prop_getter' : () => localStorage,
        'kotlinx.browser.document_$external_prop_getter' : () => document,
        'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
        'org.w3c.dom.item_$external_fun_1' : (_this, p0) => _this.item(p0),
        'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
        'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
        'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
        'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
        'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
        'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
        'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
            return {
                alpha: 1,
                depth: 1,
                stencil: 8,
                antialias: 0,
                premultipliedAlpha: 1,
                preserveDrawingBuffer: 0,
                preferLowPowerToHighPerformance: 0,
                failIfMajorPerformanceCaveat: 0,
                enableExtensionsByDefault: 1,
                explicitSwapControl: 0,
                renderViaOffscreenBackBuffer: 0,
                majorVersion: 2,
            }
        }
        ,
        'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
        'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
        'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
        'org.jetbrains.skiko.w3c.language_$external_prop_getter' : (_this) => _this.language,
        'org.jetbrains.skiko.w3c.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
        'org.jetbrains.skiko.w3c.navigator_$external_prop_getter' : (_this) => _this.navigator,
        'org.jetbrains.skiko.w3c.performance_$external_prop_getter' : (_this) => _this.performance,
        'org.jetbrains.skiko.w3c.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
        'org.jetbrains.skiko.w3c.window_$external_object_getInstance' : () => window,
        'org.jetbrains.skiko.w3c.now_$external_fun' : (_this, ) => _this.now(),
        'org.jetbrains.skiko.w3c.width_$external_prop_getter' : (_this) => _this.width,
        'org.jetbrains.skiko.w3c.height_$external_prop_getter' : (_this) => _this.height,
        'org.jetbrains.skiko.w3c.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
        'org.jetbrains.skiko.w3c.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
        'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
        'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
        'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
        'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
        'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
        'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
        'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
        'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
        'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
        'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
        'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
        'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
        'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
        'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
        'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
        'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
        'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
        'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
        'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
        'androidx.compose.ui.node.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
        'androidx.compose.ui.node.deref_$external_fun' : (_this, ) => _this.deref(),
        'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
            container.style.setProperty("--compose-internal-web-backing-input-left", left);
            container.style.setProperty("--compose-internal-web-backing-input-top", top);
            container.style.setProperty("--compose-internal-web-backing-input-width", width);
            container.style.setProperty("--compose-internal-web-backing-input-height", height)
         },
        'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
        'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
        'androidx.compose.ui.platform.selectionStart_$external_prop_getter' : (_this) => _this.selectionStart,
        'androidx.compose.ui.platform.selectionEnd_$external_prop_getter' : (_this) => _this.selectionEnd,
        'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
        'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
        'androidx.compose.ui.platform.textRangeStart_$external_prop_getter' : (_this) => _this.textRangeStart,
        'androidx.compose.ui.platform.textRangeStart_$external_prop_setter' : (_this, v) => _this.textRangeStart = v,
        'androidx.compose.ui.platform.textRangeEnd_$external_prop_getter' : (_this) => _this.textRangeEnd,
        'androidx.compose.ui.platform.textRangeEnd_$external_prop_setter' : (_this, v) => _this.textRangeEnd = v,
        'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
        'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
                window.navigator.clipboard && 
                window.navigator.clipboard.write && 
                window.navigator.clipboard.read && 
                typeof(ClipboardItem) !== 'undefined'
                )
            ,
        'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
        'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
        'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
        'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
                var roleValue = "";
                switch (ariaRoleId) {
                    case 0: // Role.Button
                        roleValue = "button";
                        break;
                    case 1: // Role.Checkbox
                        roleValue = "checkbox";
                        break;
                    case 2: // Role.Switch
                        roleValue = "switch";
                        break;
                    case 3: // Role.RadioButton
                        roleValue = "radio";
                        break;
                    case 4: // Role.Tab
                        roleValue = "tab";
                        break;
                    case 5: // Role.Image
                        roleValue = "img";
                        break;
                    case 6: // Role.DropdownList
                        roleValue = "menu";
                        break;
                    case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                        roleValue = "heading";
                        break;
                    case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                        roleValue = "textbox";
                        break;
                    case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                        roleValue = "list";
                        break;
                    case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                        roleValue = "grid";
                        break;
                    default:
                        break;
                }
                if (roleValue.length > 0) { 
                    element.setAttribute("role", roleValue);
                } else {
                    element.removeAttribute("role");
                }
             },
        'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
               element.style.left = "" + left + "px";
               element.style.top = "" + top + "px";
               element.style.width = "" + width + "px";
               element.style.height = "" + height + "px";
             },
        'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
        'androidx.compose.ui.window.touchForce' : (touch) => touch.force || 0.0,
        'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
        'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
        'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
        'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
        'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
        'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
        'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
        'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
        'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
        'org.jetbrains.compose.resources.isInTestEnvironment' : () => window.composeResourcesTesting == true,
        'org.jetbrains.compose.resources.requestResponseAsByteArray' : (req) =>  {
                var text = req.responseText;
                var int8Arr = new Int8Array(text.length);
                for (var i = 0; i < text.length; i++) {
                    int8Arr[i] = text.charCodeAt(i) & 0xFF;
                }
                return int8Arr;
            },
        'org.jetbrains.compose.resources.jsExportInt8ArrayToWasm' :  (src, size, dstAddr) => {
                const mem8 = new Int8Array(wasmExports.memory.buffer, dstAddr, size);
                mem8.set(src);
            }
        ,
        'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
        'org.jetbrains.compose.resources.supportsCacheApi' : () => Boolean(window.caches),
        'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'kotlinx.io.node.sep_$external_prop_getter' : (_this) => _this.sep,
        'kotlinx.io.node.requireExists' : () => typeof require === 'function',
        'kotlinx.io.node.requireModule' : (mod) => {
             try {
                 let m = require(mod);
                 if (m) return m;
                 return null;
             } catch (e) {
                 return null;
             }
         },
        'io.ktor.utils.io.js.decode' : (decoder, buffer) => { try { return decoder.decode(buffer) } catch(e) { return null } },
        'io.ktor.utils.io.js.tryCreateTextDecoder' : (encoding, fatal) => { try { return new TextDecoder(encoding, { fatal: fatal }) } catch(e) { return null } },
        'io.ktor.utils.io.charsets.toJsArrayImpl' : (x) => new Int8Array(x),
        'io.ktor.util._crypto_js_code' : () => ((globalThis ? globalThis.crypto : (window.crypto || window.msCrypto))),
        'io.ktor.util.getRandomValues_$external_fun' : (_this, p0) => _this.getRandomValues(p0),
        'io.ktor.util.hasNodeApi' : () => 
        (typeof process !== 'undefined' 
            && process.versions != null 
            && process.versions.node != null) ||
        (typeof window !== 'undefined' 
            && typeof window.process !== 'undefined' 
            && window.process.versions != null 
            && window.process.versions.node != null)
        ,
        'io.ktor.util.logging.getKtorLogLevel' : () => process ? process.env.KTOR_LOG_LEVEL : null,
        'io.ktor.util.logging.warn_$external_fun' : (_this, p0) => _this.warn(p0),
        'io.ktor.util.logging.debug_$external_fun' : (_this, p0) => _this.debug(p0),
        'io.ktor.util.logging.console_$external_prop_getter' : () => console,
        'io.ktor.util.toJsArrayImpl' : (x) => new Int8Array(x),
        'io.ktor.util.date.Date_$external_fun' : () => new Date(),
        'io.ktor.util.date.Date_$external_fun_1' : (p0) => new Date(p0),
        'io.ktor.util.date.getTime_$external_fun' : (_this, ) => _this.getTime(),
        'io.ktor.util.date.getUTCDate_$external_fun' : (_this, ) => _this.getUTCDate(),
        'io.ktor.util.date.getUTCDay_$external_fun' : (_this, ) => _this.getUTCDay(),
        'io.ktor.util.date.getUTCFullYear_$external_fun' : (_this, ) => _this.getUTCFullYear(),
        'io.ktor.util.date.getUTCHours_$external_fun' : (_this, ) => _this.getUTCHours(),
        'io.ktor.util.date.getUTCMinutes_$external_fun' : (_this, ) => _this.getUTCMinutes(),
        'io.ktor.util.date.getUTCMonth_$external_fun' : (_this, ) => _this.getUTCMonth(),
        'io.ktor.util.date.getUTCSeconds_$external_fun' : (_this, ) => _this.getUTCSeconds(),
        'io.ktor.http.locationOrigin' : () => function() {
            var tmpLocation = null
            if (typeof window !== 'undefined') {
              tmpLocation = window.location
            } else if (typeof self !== 'undefined') {
              tmpLocation = self.location
            }
            var origin = ""
            if (tmpLocation) {
              origin = tmpLocation.origin
            }
            return origin && origin != "null" ? origin : "http://localhost"    
        }(),
        'io.ktor.client.engine.js.createBrowserWebSocket' : (urlString_capturingHack, protocols) => new WebSocket(urlString_capturingHack, protocols),
        'io.ktor.client.engine.js.createWebSocketNodeJs' : (socketCtor, urlString_capturingHack, headers_capturingHack, protocols) => new socketCtor(urlString_capturingHack, protocols, { headers: headers_capturingHack }),
        'io.ktor.client.engine.js.getKeys' : (headers) => Array.from(headers.keys()),
        'io.ktor.client.engine.js.eventAsString' : (event) => JSON.stringify(event, ['message', 'target', 'type', 'isTrusted']),
        'io.ktor.client.engine.js.compatibility.abortControllerCtorBrowser' : () => AbortController,
        'io.ktor.client.fetch.body_$external_prop_setter' : (_this, v) => _this.body = v,
        'io.ktor.client.fetch.headers_$external_prop_setter' : (_this, v) => _this.headers = v,
        'io.ktor.client.fetch.method_$external_prop_setter' : (_this, v) => _this.method = v,
        'io.ktor.client.fetch.redirect_$external_prop_setter' : (_this, v) => _this.redirect = v,
        'io.ktor.client.fetch.signal_$external_prop_setter' : (_this, v) => _this.signal = v,
        'io.ktor.client.fetch.signal_$external_prop_getter' : (_this) => _this.signal,
        'io.ktor.client.fetch.abort_$external_fun' : (_this, ) => _this.abort(),
        'io.ktor.client.fetch.fetch_$external_fun' : (p0, p1, isDefault0) => fetch(p0, isDefault0 ? undefined : p1, ),
        'io.ktor.client.fetch.getReader_$external_fun' : (_this, ) => _this.getReader(),
        'io.ktor.client.fetch.cancel_$external_fun' : (_this, p0, isDefault0) => _this.cancel(isDefault0 ? undefined : p0, ),
        'io.ktor.client.fetch.read_$external_fun' : (_this, ) => _this.read(),
        'io.ktor.client.fetch.done_$external_prop_getter' : (_this) => _this.done,
        'io.ktor.client.fetch.value_$external_prop_getter' : (_this) => _this.value,
        'io.ktor.client.plugins.websocket.tryGetEventDataAsString' : (data) => typeof(data) === 'string' ? data : null,
        'io.ktor.client.plugins.websocket.tryGetEventDataAsArrayBuffer' : (data) => data instanceof ArrayBuffer ? data : null,
        'io.ktor.client.utils.makeJsObject' : () => { return {}; },
        'io.ktor.client.utils.makeImport' : (name) => import(name),
        'io.ktor.client.utils.makeJsCall' : (func, arg) => func.apply(null, arg),
        'io.ktor.client.utils.jsObjectAssign' : () => Object.assign,
        'io.ktor.client.utils.makeJsNew' : (ctor) => new ctor(),
        'io.ktor.client.utils.getObjectField' : (obj, name) => obj[name],
        'io.ktor.client.utils.setObjectField' : (obj, name, value) => obj[name]=value,
        'io.ktor.client.utils.toJsArrayImpl' : (x) => new Uint8Array(x),
        'startCosmicMusic' : 
            () => {
                if (window.rocketMusicRunning) return;
                window.rocketMusicRunning = true;
        
                if (!window.rocketAudioCtx) {
                    window.rocketAudioCtx = new (window.AudioContext || window.webkitAudioContext)();
                }
                const ctx = window.rocketAudioCtx;
                if (ctx.state === 'suspended') ctx.resume();
        
                // --- MASTER MUSIC VOLUME ---
                const musicMaster = ctx.createGain();
                musicMaster.gain.value = 0.30;
                musicMaster.connect(ctx.destination);
                window.rocketMusicMaster = musicMaster;
        
                // --- SPACEY DELAY (ping-pong feel via two taps) ---
                const dly1 = ctx.createDelay(); dly1.delayTime.value = 0.375;
                const dly2 = ctx.createDelay(); dly2.delayTime.value = 0.25;
                const dlyFb1 = ctx.createGain(); dlyFb1.gain.value = 0.28;
                const dlyFb2 = ctx.createGain(); dlyFb2.gain.value = 0.22;
                dly1.connect(dlyFb1).connect(dly2);
                dly2.connect(dlyFb2).connect(dly1);
                const dlyLP = ctx.createBiquadFilter();
                dlyLP.type = 'lowpass'; dlyLP.frequency.value = 4000;
                const dlyMix = ctx.createGain(); dlyMix.gain.value = 0.14;
                dly1.connect(dlyLP); dly2.connect(dlyLP);
                dlyLP.connect(dlyMix); dlyMix.connect(musicMaster);
                const dlySend = ctx.createGain(); dlySend.gain.value = 0.5;
                dlySend.connect(dly1); dlySend.connect(dly2);
        
                // =====================================================================
                //  COSMIC BUBBLE CHASE — playful space music for rockets & soap bubbles
                //  - Bright major/lydian tonality, bouncy 8th-note arpeggio pulse
                //  - Sparkly high bell "crystal" tones
                //  - Soft rhythmic kick gives momentum without being oppressive
                //  - 4-chord loop × 2 sections for variety (~45s before full repeat)
                // =====================================================================
        
                // Two sections that alternate for longer-term variety
                // Section A: bright, bouncy (C Lydian flavour)
                // Section B: dreamy, floaty  (G Mixolydian / E minor colours)
                const sections = [
                  { // --- SECTION A ---
                    chords: [
                      { root: 130.81, notes: [261.63, 329.63, 392.00, 493.88] },  // Cmaj7
                      { root: 146.83, notes: [293.66, 369.99, 440.00, 523.25] },  // D7 (lydian IV)
                      { root: 110.00, notes: [220.00, 261.63, 329.63, 392.00] },  // Am7
                      { root: 196.00, notes: [196.00, 246.94, 293.66, 392.00] },  // Gsus2
                    ],
                    arp: [523.25, 659.25, 783.99, 987.77, 1046.50, 987.77, 783.99, 659.25],
                    sparkle: [1567.98, 1318.51, 1174.66, 1046.50, 1318.51, 1567.98],
                  },
                  { // --- SECTION B ---
                    chords: [
                      { root: 164.81, notes: [329.63, 392.00, 493.88, 587.33] },  // Em9
                      { root: 174.61, notes: [349.23, 440.00, 523.25, 659.25] },  // Fmaj9
                      { root: 130.81, notes: [261.63, 329.63, 392.00, 523.25] },  // C add9
                      { root: 196.00, notes: [392.00, 493.88, 587.33, 783.99] },  // Gmaj7
                    ],
                    arp: [392.00, 493.88, 587.33, 783.99, 987.77, 783.99, 587.33, 493.88],
                    sparkle: [1975.53, 1567.98, 1318.51, 1174.66, 1567.98, 1975.53],
                  }
                ];
        
                const beatDur = 0.2;       // 8th notes at ~150 BPM — bouncy energy
                const beatsPerChord = 16;   // 2 bars per chord
                const chordsPerSection = 4;
        
                let sectionIdx = 0;
                let chordIdx = 0;
                let beat = 0;
                let arpIdx = 0;
                let nextTime = ctx.currentTime;
        
                // --- SOFT BOUNCY KICK (filtered sine, not boomy) ---
                const playKick = (time, vol) => {
                    const o = ctx.createOscillator();
                    const g = ctx.createGain();
                    o.type = 'sine';
                    o.frequency.setValueAtTime(90, time);
                    o.frequency.exponentialRampToValueAtTime(40, time + 0.08);
                    g.gain.setValueAtTime(vol, time);
                    g.gain.exponentialRampToValueAtTime(0.0001, time + 0.10);
                    o.connect(g).connect(musicMaster);
                    o.start(time); o.stop(time + 0.12);
                };
        
                // --- BUBBLY ARPEGGIO NOTE (triangle + slight detune for shimmer) ---
                const playArp = (freq, time, vol) => {
                    const len = beatDur * 1.8;
                    const o1 = ctx.createOscillator();
                    const o2 = ctx.createOscillator();
                    const g = ctx.createGain();
                    o1.type = 'triangle';
                    o2.type = 'sine';
                    o1.frequency.setValueAtTime(freq, time);
                    o2.frequency.setValueAtTime(freq * 1.003, time); // slight detune = shimmer
                    g.gain.setValueAtTime(0, time);
                    g.gain.linearRampToValueAtTime(vol, time + 0.015);
                    g.gain.exponentialRampToValueAtTime(vol * 0.3, time + len * 0.5);
                    g.gain.exponentialRampToValueAtTime(0.0001, time + len);
                    o1.connect(g); o2.connect(g);
                    g.connect(musicMaster); g.connect(dlySend);
                    o1.start(time); o1.stop(time + len + 0.05);
                    o2.start(time); o2.stop(time + len + 0.05);
                };
        
                // --- SPARKLE/CRYSTAL CHIME (high sine with fast decay — like twinkling stars) ---
                const playSparkle = (freq, time, vol) => {
                    const o = ctx.createOscillator();
                    const g = ctx.createGain();
                    o.type = 'sine';
                    o.frequency.setValueAtTime(freq, time);
                    o.frequency.setValueAtTime(freq * 0.998, time + 0.15);
                    g.gain.setValueAtTime(0, time);
                    g.gain.linearRampToValueAtTime(vol, time + 0.008);
                    g.gain.exponentialRampToValueAtTime(vol * 0.2, time + 0.2);
                    g.gain.exponentialRampToValueAtTime(0.0001, time + 0.6);
                    o.connect(g); g.connect(musicMaster); g.connect(dlySend);
                    o.start(time); o.stop(time + 0.7);
                };
        
                // --- WARM PAD (held chord, triangle, slow attack — the "space" backdrop) ---
                const playPad = (freq, time, length, vol) => {
                    const o = ctx.createOscillator();
                    const g = ctx.createGain();
                    const f = ctx.createBiquadFilter();
                    o.type = 'triangle';
                    f.type = 'lowpass'; f.frequency.value = 2200;
                    o.frequency.setValueAtTime(freq, time);
                    g.gain.setValueAtTime(0, time);
                    g.gain.linearRampToValueAtTime(vol, time + length * 0.2);
                    g.gain.setValueAtTime(vol * 0.8, time + length * 0.7);
                    g.gain.exponentialRampToValueAtTime(0.0001, time + length);
                    o.connect(f).connect(g);
                    g.connect(musicMaster);
                    o.start(time); o.stop(time + length + 0.1);
                };
        
                // --- SUB BASS (sine, gentle pulse on root) ---
                const playBass = (freq, time, length, vol) => {
                    const o = ctx.createOscillator();
                    const g = ctx.createGain();
                    o.type = 'sine';
                    o.frequency.setValueAtTime(freq, time);
                    g.gain.setValueAtTime(0, time);
                    g.gain.linearRampToValueAtTime(vol, time + 0.06);
                    g.gain.setValueAtTime(vol * 0.7, time + length * 0.5);
                    g.gain.exponentialRampToValueAtTime(0.0001, time + length);
                    o.connect(g).connect(musicMaster);
                    o.start(time); o.stop(time + length + 0.1);
                };
        
                const scheduler = () => {
                    if (nextTime < ctx.currentTime - 0.5) nextTime = ctx.currentTime;
        
                    while (nextTime < ctx.currentTime + 0.15) {
                        const sec = sections[sectionIdx];
                        const ch = sec.chords[chordIdx];
        
                        // --- On first beat of each chord: pad + bass ---
                        if (beat === 0) {
                            const chordLen = beatsPerChord * beatDur;
                            ch.notes.forEach((freq, i) => {
                                playPad(freq, nextTime + i * 0.06, chordLen - 0.2, 0.014);
                            });
                            playBass(ch.root / 2, nextTime, chordLen * 0.85, 0.03);
                        }
        
                        // --- Soft kick on beats 0, 4, 8, 12 (quarter notes) ---
                        if (beat % 4 === 0) {
                            playKick(nextTime, 0.045);
                        }
        
                        // --- Bouncy arpeggio: plays on most 8th notes with dynamic accents ---
                        // Skip some beats randomly for breathing room (~15% chance of silence)
                        if (Math.random() > 0.15) {
                            const aIdx = arpIdx % sec.arp.length;
                            // Accent pattern: louder on downbeats, softer on upbeats
                            const accent = (beat % 4 === 0) ? 0.022 : (beat % 2 === 0) ? 0.016 : 0.011;
                            playArp(sec.arp[aIdx], nextTime, accent);
                        }
                        arpIdx++;
        
                        // --- Crystal sparkle: occasional high twinkle (every ~6-10 beats) ---
                        if (Math.random() > 0.88) {
                            const sIdx = Math.floor(Math.random() * sec.sparkle.length);
                            playSparkle(sec.sparkle[sIdx], nextTime + 0.05, 0.015);
                        }
        
                        // --- Advance ---
                        beat++;
                        if (beat >= beatsPerChord) {
                            beat = 0;
                            chordIdx++;
                            if (chordIdx >= chordsPerSection) {
                                chordIdx = 0;
                                sectionIdx = (sectionIdx + 1) % sections.length;
                            }
                        }
                        nextTime += beatDur;
                    }
                    setTimeout(scheduler, 40);
                };
        
                scheduler();
            }
        ,
        'synthesizePopInternal' : 
            (distance) => {
                if (window.rocketTabHidden) return;
                if (!window.rocketAudioCtx) {
                    window.rocketAudioCtx = new (window.AudioContext || window.webkitAudioContext)();
                }
                const ctx = window.rocketAudioCtx;
                if (ctx.state === 'suspended') ctx.resume();
        
                const now = ctx.currentTime;
                const maxDist = 1000.0;
                const distanceFactor = Math.max(0, Math.min(1, (maxDist - distance) / maxDist));
                const volumeScale = Math.pow(distanceFactor, 2);
        
                if (volumeScale <= 0.01) return;
        
                const baseFreq = 550 + (Math.random() * 200);
                const duration = 0.08 + (Math.random() * 0.04);
                const osc1 = ctx.createOscillator();
                const gain1 = ctx.createGain();
                osc1.type = 'sine';
                osc1.frequency.setValueAtTime(baseFreq, now);
                osc1.frequency.exponentialRampToValueAtTime(baseFreq * 1.8, now + duration);
                gain1.gain.setValueAtTime(0.0001, now);
                gain1.gain.linearRampToValueAtTime(0.02 * volumeScale, now + 0.01);
                gain1.gain.exponentialRampToValueAtTime(0.0001, now + duration + 0.02);
                osc1.connect(gain1).connect(ctx.destination);
                osc1.start(now);
                osc1.stop(now + duration + 0.05);
        
                // Echo/Sparkle
                const echoDelay = 0.05;
                const osc2 = ctx.createOscillator();
                const gain2 = ctx.createGain();
                osc2.type = 'sine';
                osc2.frequency.setValueAtTime(2500, now + echoDelay);
                gain2.gain.setValueAtTime(0.0001, now + echoDelay);
                gain2.gain.linearRampToValueAtTime(0.008 * volumeScale, now + echoDelay + 0.005);
                gain2.gain.exponentialRampToValueAtTime(0.0001, now + echoDelay + 0.04);
                osc2.connect(gain2).connect(ctx.destination);
                osc2.start(now + echoDelay);
                osc2.stop(now + echoDelay + 0.05);
            }
        ,
        'synthesizeGlassInternal' : 
            (distance) => {
                if (window.rocketTabHidden) return;
                if (!window.rocketAudioCtx) {
                    window.rocketAudioCtx = new (window.AudioContext || window.webkitAudioContext)();
                }
                const ctx = window.rocketAudioCtx;
                if (ctx.state === 'suspended') ctx.resume();
        
                const now = ctx.currentTime;
                const maxDist = 1200.0;
                const distanceFactor = Math.max(0, Math.min(1, (maxDist - distance) / maxDist));
                const volumeScale = Math.pow(distanceFactor, 1.5);
        
                if (volumeScale <= 0.005) return;
        
                // Glass physics: 1 base freq + several inharmonic overtones
                // Standard glass ratios are roughly 1: 2.32 : 4.25 : 6.63
                const baseFreq = 2200 + (Math.random() * 400);
                const ratios = [1, 2.32, 4.1, 7.8];
                const duration = 0.22;
        
                // High pass filter to remove "thud" and keep "shimmer"
                const highPass = ctx.createBiquadFilter();
                highPass.type = "highpass";
                highPass.frequency.value = 1000;
                highPass.connect(ctx.destination);
        
                ratios.forEach((ratio, i) => {
                    const osc = ctx.createOscillator();
                    const gain = ctx.createGain();
        
                    osc.type = 'sine';
                    osc.frequency.setValueAtTime(baseFreq * ratio, now);
        
                    // Fast attack, moderate decay — loud enough to hear across the screen
                    gain.gain.setValueAtTime(0, now);
                    gain.gain.linearRampToValueAtTime(0.32 * (1/(i+1)) * volumeScale, now + 0.002);
                    gain.gain.exponentialRampToValueAtTime(0.0001, now + (duration / (i + 1)));
        
                    osc.connect(gain).connect(highPass);
                    osc.start(now);
                    osc.stop(now + duration);
                });
            }
        ,
        'synthesizeZapInternal' : 
            (distance) => {
                if (window.rocketTabHidden) return;
                if (!window.rocketAudioCtx) {
                    window.rocketAudioCtx = new (window.AudioContext || window.webkitAudioContext)();
                }
                const ctx = window.rocketAudioCtx;
                if (ctx.state === 'suspended') ctx.resume();
        
                const now = ctx.currentTime;
                const maxDist = 1000.0;
                const distanceFactor = Math.max(0, Math.min(1, (maxDist - distance) / maxDist));
                const volumeScale = Math.pow(distanceFactor, 1.5);
        
                if (volumeScale <= 0.005) return;
        
                // --- HIGH-VOLTAGE ZAP ARCHITECTURE ---
                // Layer 1: Burst oscillator — a sawtooth sweep from high to low (electrical discharge)
                const osc1 = ctx.createOscillator();
                const gain1 = ctx.createGain();
                osc1.type = 'sawtooth';
                osc1.frequency.setValueAtTime(3200 + Math.random() * 800, now);
                osc1.frequency.exponentialRampToValueAtTime(180, now + 0.12);
                gain1.gain.setValueAtTime(0, now);
                gain1.gain.linearRampToValueAtTime(0.18 * volumeScale, now + 0.003);
                gain1.gain.exponentialRampToValueAtTime(0.0001, now + 0.14);
                osc1.connect(gain1).connect(ctx.destination);
                osc1.start(now);
                osc1.stop(now + 0.15);
        
                // Layer 2: Noise-like square crackle — gives the "electric" texture
                const osc2 = ctx.createOscillator();
                const gain2 = ctx.createGain();
                const distortion = ctx.createWaveShaper();
                // Hard-clip waveshaper for harsh bite
                const curve = new Float32Array(256);
                for (let i = 0; i < 256; i++) {
                    const x = (i * 2) / 256 - 1;
                    curve[i] = x < 0 ? -1 : 1;  // hard clip → square-ify
                }
                distortion.curve = curve;
                osc2.type = 'square';
                osc2.frequency.setValueAtTime(60 + Math.random() * 40, now);
                gain2.gain.setValueAtTime(0, now);
                gain2.gain.linearRampToValueAtTime(0.08 * volumeScale, now + 0.004);
                gain2.gain.exponentialRampToValueAtTime(0.0001, now + 0.1);
                osc2.connect(distortion).connect(gain2).connect(ctx.destination);
                osc2.start(now);
                osc2.stop(now + 0.12);
        
                // Layer 3: High-frequency "sizzle" tail — the ionized air shimmer after the bolt
                const osc3 = ctx.createOscillator();
                const gain3 = ctx.createGain();
                const highPass = ctx.createBiquadFilter();
                highPass.type = 'highpass';
                highPass.frequency.value = 6000;
                osc3.type = 'sawtooth';
                osc3.frequency.setValueAtTime(8000 + Math.random() * 2000, now + 0.01);
                osc3.frequency.exponentialRampToValueAtTime(4000, now + 0.18);
                gain3.gain.setValueAtTime(0, now + 0.01);
                gain3.gain.linearRampToValueAtTime(0.06 * volumeScale, now + 0.02);
                gain3.gain.exponentialRampToValueAtTime(0.0001, now + 0.2);
                osc3.connect(highPass).connect(gain3).connect(ctx.destination);
                osc3.start(now + 0.01);
                osc3.stop(now + 0.22);
            }
        ,
        'synthesizeBalloonPopInternal' : 
            (distance) => {
                if (window.rocketTabHidden) return;
                if (!window.rocketAudioCtx) {
                    window.rocketAudioCtx = new (window.AudioContext || window.webkitAudioContext)();
                }
                const ctx = window.rocketAudioCtx;
                if (ctx.state === 'suspended') ctx.resume();
        
                const now = ctx.currentTime;
                const maxDist = 1400.0;
                const distanceFactor = Math.max(0, Math.min(1, (maxDist - distance) / maxDist));
                const volumeScale = Math.pow(distanceFactor, 1.5);
        
                if (volumeScale <= 0.005) return;
        
                // Layer 1: Low BOOM — the membrane snapping (sine sweep, 110 Hz → 28 Hz)
                const boom = ctx.createOscillator();
                const boomGain = ctx.createGain();
                boom.type = 'sine';
                boom.frequency.setValueAtTime(110, now);
                boom.frequency.exponentialRampToValueAtTime(28, now + 0.28);
                boomGain.gain.setValueAtTime(0, now);
                boomGain.gain.linearRampToValueAtTime(0.55 * volumeScale, now + 0.002);
                boomGain.gain.exponentialRampToValueAtTime(0.0001, now + 0.32);
                boom.connect(boomGain).connect(ctx.destination);
                boom.start(now);
                boom.stop(now + 0.35);
        
                // Layer 2: Air rush — sawtooth through bandpass filter for the escaping air whoosh
                const air = ctx.createOscillator();
                const airGain = ctx.createGain();
                const airFilter = ctx.createBiquadFilter();
                airFilter.type = 'bandpass';
                airFilter.frequency.value = 400;
                airFilter.Q.value = 0.8;
                air.type = 'sawtooth';
                air.frequency.setValueAtTime(220, now);
                air.frequency.exponentialRampToValueAtTime(55, now + 0.2);
                airGain.gain.setValueAtTime(0, now);
                airGain.gain.linearRampToValueAtTime(0.18 * volumeScale, now + 0.003);
                airGain.gain.exponentialRampToValueAtTime(0.0001, now + 0.22);
                air.connect(airFilter).connect(airGain).connect(ctx.destination);
                air.start(now);
                air.stop(now + 0.25);
        
                // Layer 3: Sharp rubber snap — very brief square burst (~900 Hz)
                const snap = ctx.createOscillator();
                const snapGain = ctx.createGain();
                snap.type = 'square';
                snap.frequency.setValueAtTime(900 + Math.random() * 200, now);
                snap.frequency.exponentialRampToValueAtTime(200, now + 0.06);
                snapGain.gain.setValueAtTime(0, now);
                snapGain.gain.linearRampToValueAtTime(0.12 * volumeScale, now + 0.001);
                snapGain.gain.exponentialRampToValueAtTime(0.0001, now + 0.07);
                snap.connect(snapGain).connect(ctx.destination);
                snap.start(now);
                snap.stop(now + 0.08);
            }
        ,
        'synthesizeBilliardHitInternal' : 
            (distance) => {
                if (window.rocketTabHidden) return;
                if (!window.rocketAudioCtx) {
                    window.rocketAudioCtx = new (window.AudioContext || window.webkitAudioContext)();
                }
                const ctx = window.rocketAudioCtx;
                if (ctx.state === 'suspended') ctx.resume();
        
                const now = ctx.currentTime;
                const maxDist = 1100.0;
                const distanceFactor = Math.max(0, Math.min(1, (maxDist - distance) / maxDist));
                const volumeScale = Math.pow(distanceFactor, 1.5);
        
                if (volumeScale <= 0.005) return;
        
                // Billiard balls are dense phenolic resin — hard, bright, very short "clack"
                // The pitch varies slightly with relative impact speed (simulated with randomness)
                const baseFreq = 900 + Math.random() * 200;
        
                // --- ECHO BUS: two taps at 80ms and 160ms, decaying ---
                const echoDelay1 = ctx.createDelay();
                echoDelay1.delayTime.value = 0.08;
                const echoDelay2 = ctx.createDelay();
                echoDelay2.delayTime.value = 0.16;
                const echoGain1 = ctx.createGain();
                echoGain1.gain.value = 0.18 * volumeScale;
                const echoGain2 = ctx.createGain();
                echoGain2.gain.value = 0.08 * volumeScale;
                const echoBus = ctx.createGain();
                echoBus.gain.value = 1.0;
                echoBus.connect(echoDelay1);
                echoBus.connect(echoDelay2);
                echoDelay1.connect(echoGain1).connect(ctx.destination);
                echoDelay2.connect(echoGain2).connect(ctx.destination);
        
                // Layer 1: Primary "clack" — sine at fundamental, near-instant attack, sharp decay
                const clack = ctx.createOscillator();
                const clackGain = ctx.createGain();
                clack.type = 'sine';
                clack.frequency.setValueAtTime(baseFreq, now);
                clack.frequency.exponentialRampToValueAtTime(baseFreq * 0.6, now + 0.08);
                clackGain.gain.setValueAtTime(0, now);
                clackGain.gain.linearRampToValueAtTime(0.22 * volumeScale, now + 0.0005);
                clackGain.gain.exponentialRampToValueAtTime(0.0001, now + 0.1);
                clack.connect(clackGain);
                clackGain.connect(ctx.destination);
                clackGain.connect(echoBus);
                clack.start(now);
                clack.stop(now + 0.12);
        
                // Layer 2: Harmonic overtone — gives the bright "ring" of a hard sphere
                const ring = ctx.createOscillator();
                const ringGain = ctx.createGain();
                ring.type = 'sine';
                ring.frequency.setValueAtTime(baseFreq * 2.1, now);
                ring.frequency.exponentialRampToValueAtTime(baseFreq * 1.4, now + 0.06);
                ringGain.gain.setValueAtTime(0, now);
                ringGain.gain.linearRampToValueAtTime(0.10 * volumeScale, now + 0.0005);
                ringGain.gain.exponentialRampToValueAtTime(0.0001, now + 0.07);
                ring.connect(ringGain);
                ringGain.connect(ctx.destination);
                ringGain.connect(echoBus);
                ring.start(now);
                ring.stop(now + 0.09);
        
                // Layer 3: Transient click — a very short broadband burst for the initial impact crack
                const click = ctx.createOscillator();
                const clickGain = ctx.createGain();
                const clickFilter = ctx.createBiquadFilter();
                clickFilter.type = 'highpass';
                clickFilter.frequency.value = 1000;
                click.type = 'square';
                click.frequency.setValueAtTime(1300 + Math.random() * 300, now);
                clickGain.gain.setValueAtTime(0.12 * volumeScale, now);
                clickGain.gain.exponentialRampToValueAtTime(0.0001, now + 0.012);
                click.connect(clickFilter).connect(clickGain);
                clickGain.connect(ctx.destination);
                clickGain.connect(echoBus);
                click.start(now);
                click.stop(now + 0.015);
            }
        ,
        'synthesizeStaticInternal' : 
            (distance) => {
                if (window.rocketTabHidden) return;
                if (!window.rocketAudioCtx) {
                    window.rocketAudioCtx = new (window.AudioContext || window.webkitAudioContext)();
                }
                const ctx = window.rocketAudioCtx;
                if (ctx.state === 'suspended') ctx.resume();
        
                const maxDist = 1000.0;
                const distanceFactor = Math.max(0, Math.min(1, (maxDist - distance) / maxDist));
                const volumeScale = Math.pow(distanceFactor, 1.5);
        
                if (volumeScale <= 0.005) return;
        
                // How long (ms) after the last call before the effect fades out
                const holdMs = 350;
        
                // The LFO runs at 0.8 Hz and swings the master gain between ~31% and ~100% of peak.
                // DC offset + LFO depth are split so the sine modulates around the centre value:
                //   gain = lfoCenter ± lfoDepth  →  range [0.04 .. 0.13] * volumeScale
                const lfoCenter = 0.085 * volumeScale;
                const lfoDepth  = 0.045 * volumeScale;
        
                // Shared stop/cleanup — cancels sparks, fades master, disposes nodes
                const stopAll = () => {
                    if (window.rocketSparkTimers) {
                        window.rocketSparkTimers.forEach(t => clearTimeout(t));
                        window.rocketSparkTimers = [];
                    }
                    if (window.rocketStaticGain) {
                        window.rocketStaticGain.gain.setTargetAtTime(0.0001, ctx.currentTime, 0.03);
                    }
                    setTimeout(() => {
                        ['rocketStaticBuzzOsc', 'rocketStaticHissSrc', 'rocketStaticLFO'].forEach(k => {
                            if (window[k]) { try { window[k].stop(); } catch(e) {} window[k] = null; }
                        });
                        window.rocketStaticGain = null;
                    }, 200);
                };
        
                // --- KEEP-ALIVE: if already running, just extend lifetime + track new distance ---
                if (window.rocketStaticGain) {
                    clearTimeout(window.rocketStaticStopTimer);
                    // Update the DC offset; the LFO is already connected and keeps swinging around it
                    window.rocketStaticGain.gain.setTargetAtTime(lfoCenter, ctx.currentTime, 0.02);
                    window.rocketStaticStopTimer = setTimeout(stopAll, holdMs);
                    return;
                }
        
                // ─────────────────────────────────────────────────────────────────────
                // HIGH-VOLTAGE PROXIMITY EFFECT
                //   Layer 1 — Electric arc buzz  (sawtooth → tanh distortion → bandpass)
                //   Layer 2 — Corona hiss        (narrow-band noise, 5–7 kHz)
                //   Layer 3 — Random sparks      (internally scheduled, organic timing)
                //   LFO     — 0.8 Hz sine AM on master gain (slow electrical "breathing")
                // ─────────────────────────────────────────────────────────────────────
        
                // Master gain — DC offset is lfoCenter; LFO will be added on top
                const masterGain = ctx.createGain();
                masterGain.gain.setValueAtTime(0.0001, ctx.currentTime);
                masterGain.gain.linearRampToValueAtTime(lfoCenter, ctx.currentTime + 0.06);
                masterGain.connect(ctx.destination);
                window.rocketStaticGain = masterGain;
        
                // 0.8 Hz LFO connected to masterGain.gain as an AudioParam modulator.
                // Output of lfoOsc is ±1; scaled by lfoDepthGain → ±lfoDepth added to the DC offset.
                const lfoOsc = ctx.createOscillator();
                lfoOsc.type = 'sine';
                lfoOsc.frequency.value = 0.8;
                const lfoDepthGain = ctx.createGain();
                lfoDepthGain.gain.value = lfoDepth;
                lfoOsc.connect(lfoDepthGain);
                lfoDepthGain.connect(masterGain.gain); // modulates the gain AudioParam
                lfoOsc.start();
                window.rocketStaticLFO = lfoOsc;
        
                // --- Layer 1: Arc buzz ---
                // Sawtooth at 80 Hz gives a dense harmonic stack (like a transformer or arc welder).
                const buzzOsc = ctx.createOscillator();
                buzzOsc.type = 'sawtooth';
                buzzOsc.frequency.value = 80;
        
                // tanh soft-clip with high drive → harsh, buzzy, but not a square wave
                const driveCurve = new Float32Array(512);
                for (let i = 0; i < 512; i++) {
                    const x = (i * 2) / 512 - 1;
                    driveCurve[i] = Math.tanh(x * 10);
                }
                const buzzDist = ctx.createWaveShaper();
                buzzDist.curve = driveCurve;
        
                // Bandpass shaped to the 300–3500 Hz "electrical arc" region
                const buzzBP = ctx.createBiquadFilter();
                buzzBP.type = 'bandpass';
                buzzBP.frequency.value = 1100;
                buzzBP.Q.value = 0.55;
        
                const buzzGain = ctx.createGain();
                buzzGain.gain.value = 0.75;
        
                buzzOsc.connect(buzzDist);
                buzzDist.connect(buzzBP);
                buzzBP.connect(buzzGain);
                buzzGain.connect(masterGain);
                buzzOsc.start();
                window.rocketStaticBuzzOsc = buzzOsc;
        
                // --- Layer 2: Corona hiss ---
                // Narrow-band noise centred at ~6 kHz — the ionised-air sizzle above an arc.
                const hissBufLen = ctx.sampleRate * 2;
                const hissBuf = ctx.createBuffer(1, hissBufLen, ctx.sampleRate);
                const hissData = hissBuf.getChannelData(0);
                for (let i = 0; i < hissBufLen; i++) hissData[i] = Math.random() * 2 - 1;
        
                const hissSrc = ctx.createBufferSource();
                hissSrc.buffer = hissBuf;
                hissSrc.loop = true;
        
                // High Q → narrow sizzle, not broadband noise
                const hissBP = ctx.createBiquadFilter();
                hissBP.type = 'bandpass';
                hissBP.frequency.value = 6200;
                hissBP.Q.value = 3.0;
        
                const hissGain = ctx.createGain();
                hissGain.gain.value = 0.5;
        
                hissSrc.connect(hissBP);
                hissBP.connect(hissGain);
                hissGain.connect(masterGain);
                hissSrc.start();
                window.rocketStaticHissSrc = hissSrc;
        
                // --- Layer 3: Internally-generated random sparks ---
                // Sparks fire at random, organic intervals so there is NO rhythmic pattern.
                // Each spark is a very short noise burst through a high-pass filter.
                window.rocketSparkTimers = [];
                const fireSpark = () => {
                    if (!window.rocketStaticGain) return; // sound stopped — halt recursion
        
                    const sparkLen = Math.floor(ctx.sampleRate * (0.006 + Math.random() * 0.010));
                    const sparkBuf = ctx.createBuffer(1, sparkLen, ctx.sampleRate);
                    const sd = sparkBuf.getChannelData(0);
                    for (let i = 0; i < sparkLen; i++) sd[i] = Math.random() * 2 - 1;
        
                    const sparkSrc = ctx.createBufferSource();
                    sparkSrc.buffer = sparkBuf;
        
                    // High-pass filter keeps sparks crisp and above the buzz layer
                    const sparkHP = ctx.createBiquadFilter();
                    sparkHP.type = 'highpass';
                    sparkHP.frequency.value = 5000 + Math.random() * 4000;
        
                    const sparkG = ctx.createGain();
                    // Instant attack, very fast exponential decay — a true snap, not a pop
                    const sparkVol = (0.08 + Math.random() * 0.12) * volumeScale;
                    sparkG.gain.setValueAtTime(sparkVol, ctx.currentTime);
                    sparkG.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.010);
        
                    // Connect directly to destination so sparks cut through regardless of master gain
                    sparkSrc.connect(sparkHP);
                    sparkHP.connect(sparkG);
                    sparkG.connect(ctx.destination);
                    sparkSrc.start();
                    sparkSrc.stop(ctx.currentTime + 0.015);
        
                    // Schedule next spark — short range keeps density high, randomness prevents rhythm
                    const nextMs = 50 + Math.random() * 130;
                    window.rocketSparkTimers.push(setTimeout(fireSpark, nextMs));
                };
        
                // First spark fires after a short random delay so it doesn't coincide with the Zap
                window.rocketSparkTimers.push(setTimeout(fireSpark, 40 + Math.random() * 80));
        
                // Auto-stop scheduled for holdMs after this call
                window.rocketStaticStopTimer = setTimeout(stopAll, holdMs);
            }
        ,
        'setMusicEnabledInternal' : 
            (enabled) => {
                if (window.rocketMusicMaster) {
                    const ctx = window.rocketAudioCtx;
                    if (ctx && enabled) {
                        // Fade in over 0.5s
                        window.rocketMusicMaster.gain.cancelScheduledValues(ctx.currentTime);
                        window.rocketMusicMaster.gain.setTargetAtTime(0.30, ctx.currentTime, 0.15);
                    } else if (ctx) {
                        // Fade out over ~1.5s (time constant 0.5 → ~95% fade in 1.5s)
                        window.rocketMusicMaster.gain.cancelScheduledValues(ctx.currentTime);
                        window.rocketMusicMaster.gain.setTargetAtTime(0.0001, ctx.currentTime, 0.5);
                    } else {
                        window.rocketMusicMaster.gain.value = enabled ? 0.30 : 0.0;
                    }
                }
            }
        ,
        'setupAudioVisibilityListener' : 
            () => {
                if (window.rocketVisibilityListenerInstalled) return;
                window.rocketVisibilityListenerInstalled = true;
        
                document.addEventListener('visibilitychange', () => {
                    const ctx = window.rocketAudioCtx;
                    if (document.hidden) {
                        window.rocketTabHidden = true;
                        if (ctx) ctx.suspend();
                    } else {
                        window.rocketTabHidden = false;
                        if (ctx) ctx.resume();
                    }
                });
            }
        ,
        'openUrlJs' : (url) => { window.open(url, '_blank', 'noopener'); },
        'setKeyGateEnabled' : (enabled) => { window.gameKeyGateEnabled = enabled; if (!enabled) window.heldGameKeys = {}; },
        'fetchTextJs' : 
        (url, onSuccess, onError) => {
            fetch(url)
                .then(r => r.text())
                .then(text => onSuccess(text))
                .catch(e => onError('' + e));
        }
        ,
        'pingServerJs' : 
        (host, port, onResult) => {
            const protocol = (port === 443) ? 'https' : 'http';
            const portSuffix = (port === 443 || port === 80) ? '' : ':' + port;
            const url = protocol + '://' + host + portSuffix + '/ping';
            const start = performance.now();
            fetch(url, { method: 'GET', mode: 'cors', cache: 'no-store' })
                .then(() => onResult('' + Math.round(performance.now() - start)))
                .catch(() => onResult('-1'));
        }
        
    }
    
    // Placed here to give access to it from externals (js_code)
    let wasmInstance;
    let require; 
    let wasmExports;

    const isNodeJs = (typeof process !== 'undefined') && (process.release.name === 'node');
    const isDeno = !isNodeJs && (typeof Deno !== 'undefined')
    const isStandaloneJsVM =
        !isDeno && !isNodeJs && (
            typeof d8 !== 'undefined' // V8
            || typeof inIon !== 'undefined' // SpiderMonkey
            || typeof jscOptions !== 'undefined' // JavaScriptCore
        );
    const isBrowser = !isNodeJs && !isDeno && !isStandaloneJsVM && (typeof window !== 'undefined' || typeof self !== 'undefined');
    
    if (!isNodeJs && !isDeno && !isStandaloneJsVM && !isBrowser) {
      throw "Supported JS engine not detected";
    }

    const wasmFilePath = './fatrocket-webApp.wasm';

    const importObject = {
        js_code,
        intrinsics: {
            tag: wasmTag
        },
        './skiko.mjs': imports['./skiko.mjs'],


    };
    
    try {
      if (isNodeJs) {
        const module = await import(/* webpackIgnore: true */'node:module');
        const importMeta = import.meta;
        require = module.default.createRequire(importMeta.url);
        const fs = require('fs');
        const url = require('url');
        const filepath = import.meta.resolve(wasmFilePath);
        const wasmBuffer = fs.readFileSync(url.fileURLToPath(filepath));
        const wasmModule = new WebAssembly.Module(wasmBuffer);
        wasmInstance = new WebAssembly.Instance(wasmModule, importObject, { builtins: [''] });
      }
      
      if (isDeno) {
        const path = await import(/* webpackIgnore: true */'https://deno.land/std/path/mod.ts');
        const binary = Deno.readFileSync(path.fromFileUrl(import.meta.resolve(wasmFilePath)));
        const module = await WebAssembly.compile(binary);
        wasmInstance = await WebAssembly.instantiate(module, importObject, { builtins: [''] });
      }
      
      if (isStandaloneJsVM) {
        const wasmBuffer = read(wasmFilePath, 'binary');
        const wasmModule = new WebAssembly.Module(wasmBuffer);
        wasmInstance = new WebAssembly.Instance(wasmModule, importObject, { builtins: [''] });
      }
      
      if (isBrowser) {
        wasmInstance = (await WebAssembly.instantiateStreaming(fetch(new URL('./fatrocket-webApp.wasm',import.meta.url).href), importObject, { builtins: [''] })).instance;
      }
    } catch (e) {
      if (e instanceof WebAssembly.CompileError) {
        let text = `Please make sure that your runtime environment supports the latest version of Wasm GC and Exception-Handling proposals.
For more information, see https://kotl.in/wasm-help
`;
        if (isBrowser) {
          console.error(text);
        } else {
          const t = "\n" + text;
          if (typeof console !== "undefined" && console.log !== void 0) 
            console.log(t);
          else 
            print(t);
        }
      }
      throw e;
    }
    
    wasmExports = wasmInstance.exports;
    if (runInitializer) {
        wasmExports._initialize();
    }

    return { instance: wasmInstance,  exports: wasmExports };
}
